import { render, staticRenderFns } from "./exibir-lei-18419-2015.vue?vue&type=template&id=119f0f1e&"
import script from "./exibir-lei-18419-2015.vue?vue&type=script&lang=js&"
export * from "./exibir-lei-18419-2015.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119f0f1e')) {
      api.createRecord('119f0f1e', component.options)
    } else {
      api.reload('119f0f1e', component.options)
    }
    module.hot.accept("./exibir-lei-18419-2015.vue?vue&type=template&id=119f0f1e&", function () {
      api.rerender('119f0f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/legislacao/exibir-lei-18419-2015.vue"
export default component.exports